export const consultPageLink = '/consult'
